module.exports = __webpack_public_path__ + "static/media/rd-glove.c8cf9e4f.jpg";